module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.ico
// module id = 312
// module chunks = 0